import { masterHighQualityCategoryPath } from './text'

export function resolveNavHref(level, link, title) {
  if (level === 'parent') return link
  if (level !== 'children' || link == null || link === '') return '#'

  if (title === '精品荟萃') return `/highQuality/${link}`
  if (title === '行业简介') return `/industryIntroduction/${link}`
  if (title === '大师云集') return `/master/index?msgType=${link}`
  if (title === '非遗传承') return `/heritage/index?msgType=${link}`
  if (typeof link === 'string' && link.startsWith('/')) return link
  return '#'
}

export function buildDetailHref(routeName, params = {}) {
  switch (routeName) {
    case 'newsNoticeDetail':
      return `/newsNotice/detail/${params.id}`
    case 'interviewsDetail':
      return `/interviews/detail/${params.id}`
    case 'researchDetail':
      return `/research/detail/${params.id}`
    case 'masterDetail':
      return `/master/detail/${params.msgType}/${params.id}`
    case 'heritageDetail':
      return `/heritage/detail/${params.msgType}/${params.id}`
    case 'highQualityDetail':
      return `/highQuality/${params.msgType}/detail/${params.id}`
    case 'masterHighQualityDetail':
      return `/masterHighQuality/detail/${encodeURIComponent(params.name)}/${params.msgType}/${params.id}`
    case 'masterHighQualityCategory':
      return masterHighQualityCategoryPath(params.msgType, params.name)
    case 'highQuality':
      return `/highQuality/${params.msgType}`
    case 'industryIntroduction':
      return `/industryIntroduction/${params.msgType}`
    default:
      return '/'
  }
}

export { masterHighQualityCategoryPath }
